module.exports = __webpack_public_path__ + "@/assets/img/bannerReferido.e035f517.gif";